<template>
  <v-container>
    <v-row>
      <v-col>
          <h2>TORNEOS MDK</h2>
        <v-row>
            <v-col>
                <v-checkbox label="Solo este año" v-model="filterThisYearOnly"></v-checkbox>
            </v-col>
        </v-row>
          <GlobalEventProcessIndex
            :permissionRoot="'Torneos,Doyang Torneos'"
            :storeModel="storeModel"
            :routeCreate="routeCreate"
            :routeProspects="routeProspects"
            :routeEdit="routeEdit"
            :filterThisYearOnly="filterThisYearOnly"
          />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GlobalEventProcessIndex from '../globals/CRUDEventProcessIndex'
export default {
  components: {
    GlobalEventProcessIndex
  },
  data () {
    return {
      headers: [
        { text: 'Torneo', value: 'name' },
        { text: 'Fecha', value: 'date' },
      ],
      filterThisYearOnly: true,
      storeModel: 'Tournament',
      routeCreate: 'TournamentCreate',
      routeEdit: 'TournamentEdit',
      routeProspects: 'TournamentProspects',
      itemsPerPage: 20
    }
  },
}
</script>

<style>

</style>
